<template>
  <result-wrapper class="simple-result"
                  :icon-name="iconName"
                  :element-data="elementData">
    <span class="card-title ms-2" v-html="displayName"></span>
  </result-wrapper>
</template>

<script>
import ResultWrapper from "@/components/card/ResultWrapper.vue";

export default {
  name: "Generic",
  props: {
    elementKey: String,
    elementData: Object,
  },
  components: {
    ResultWrapper,
  },
  data() {
    return {
      details: {
        jobbox: { icon: 'job-box' },
        translationbox: { icon: 'translation' },
        locationcontainer: { icon: 'location', displayName: 'Locations' },
        livesports: { icon: 'live-sports' },
        thingstoknowbox: { icon: 'things-to-know-box', displayName: 'Things To Know' },
        aboutcarousel: { icon: 'about-carousel', displayName: 'About' },
        publicationsbox: { icon: 'publications', displayName: 'Publications' },
        productsite: { icon: 'productsite', displayName: 'Product Sites' },
        products: { icon: 'products', displayName: 'Products' }
      },
    }
  },
  computed: {
    iconName() {
      return this.details[this.elementData.resulttype]?.icon;
    },
    displayName() {
      return this.details[this.elementData.resulttype]?.displayName || this.elementData.displayName;
    },
  }
};
</script>

<style lang="scss" scoped></style>
